<template>
  <div>
    <div class="top-deco">&nbsp;</div>
    <form
      @submit.prevent="do_submit"
      ref="contact_form"
      :class="form_class"
      v-if="contact_form_status == 0"
    >
      <div class="sm:grid sm:grid-cols-3 sm:gap-3 mt-3">
        <div class="sm:col-span-2 form-content">
          <h1 class="text-main-color">
            Supernus<br />
            Medical Request Form
          </h1>

          <div class="block text-main-color py-4 form-instructions">
            Please complete the form below to connect with a RMM (Regional
            Medical Manager) from Supernus
          </div>

          <div class="">
            <template v-for="item in form_model">
              <SimpleTextField
                :id="item.id"
                :label="item.label"
                v-model="item.value"
                :extra_field_class="item.extra_class"
                :type="item.type"
                v-if="item.type == 'text'"
                :key="item.id"
                :required="item.required"
              />
              <SimpleTextArea
                :id="item.id"
                :label="item.label"
                v-model="item.value"
                :extra_field_class="item.extra_class"
                :type="item.type"
                v-if="item.type == 'textarea'"
                :key="item.id"
                :required="item.required"
              />
              <SimpleSelectBox
                :id="item.id"
                :label="item.label"
                v-model="item.value"
                :extra_field_class="item.extra_class"
                :type="item.type"
                :options="item.options"
                v-if="item.type == 'selectbox'"
                :key="item.id"
                :required="item.required"
              />
              <HiddenField
                :id="item.id"
                v-model="item.value"
                v-if="item.type == 'hidden'"
                :key="item.id"
              />
            </template>
          </div>

          <div class="mt-3">
            <template v-for="item in form_model">
              <div :key="item.id" v-if="item.type == 'checkboxgroup'">
                <div class="mt-4">
                  <label
                    class="block text-gray-700 text-sm font-bold mb-0 sm:mb-2"
                    ><span :class="item.extra_class"
                      >{{ item.label }} *</span
                    ></label
                  >
                </div>
                <div class="grid grid-cols-1">
                  <label
                    v-for="checkbox_option in item.options"
                    class="block text-sm mb-1"
                  >
                    <input
                      v-model="item.value"
                      :name="item.id + '[]'"
                      type="checkbox"
                      :value="checkbox_option[0]"
                    />&nbsp;&nbsp;{{ checkbox_option[1] }}
                  </label>
                </div>
              </div>
            </template>
          </div>

          <div class="text-justify text-main-color">
            By completing this form, you acknowledge a Regional Medical
            Manager<br />
            will contact you in response to your question.
          </div>

          <div class="mt-4 submit-container">
            <button
              class="bg-default-btn-color hover:bg-default-btn-color-hover text-main-color py-3 px-12 focus:outline-none focus:shadow-outline"
              type="submit"
            >
              Submit
            </button>
          </div>
        </div>
        <div>
          <img src="static/img/logo.svg" class="logo" />
        </div>
      </div>
    </form>
    <div
      class="max-h-screen py-24 text-center border-white border-2"
      v-if="contact_form_status == 1"
    >
      <img src="../../assets/loading.svg" class="mx-auto" />
    </div>
    <div
      class="success pt-40 text-center text-main-color"
      v-if="contact_form_status == 2"
    >
      <div class="thankyou-header">Thank you.</div>
      <div class="thankyou-msg">
        Your request has been sent.<br />
        A Supernus representative will get back to you shortly.
      </div>
      <div class="thankyou-logo">
        <img src="static/img/logo.svg" />
      </div>
    </div>
    <div class="error pt-40 text-center" v-if="contact_form_status == 3">
      <div class="thankyou-error text-red-500 text-2xl pb-10">
        Sorry, there was an error!
      </div>
      <div class="thankyou-msg">
        The form could not be submitted. Please try again.
      </div>
      <div class="thankyou-logo">
        <img src="static/img/logo.svg" />
      </div>
    </div>
    <div class="bottom-deco">&nbsp;</div>
  </div>
</template>
<script>
import SimpleTextField from "../form/SimpleTextField";
import SimpleTextArea from "../form/SimpleTextArea";
import SimpleSelectBox from "../form/SimpleSelectBox";
import HiddenField from "../form/HiddenField";
import { mapState, mapGetters } from "vuex";

export default {
  name: "ContactForm",
  components: {
    SimpleTextField,
    HiddenField,
    SimpleTextArea,
    SimpleSelectBox
  },
  data() {
    return {
      form_class: "contact_form_page",
      timer: null,

      form_model: [
        {
          id: "name",
          type: "text",
          required: true,
          label: "Name",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },
        {
          id: "email",
          type: "text",
          required: true,
          label: "Email",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },

        {
          id: "message",
          type: "textarea",
          required: true,
          label: "Question/message for Supernus RMM",
          value: "",
          extra_class: "",
          validation: ["notempty"]
        },

        {
          id: "institution",
          type: "text",
          required: true,
          label: "Institution (optional)",
          value: "",
          extra_class: "flex-1",
          validation: []
        },
        {
          id: "event_tag",
          type: "hidden",
          required: false,
          label: "Event Tag",
          value: "",
          extra_class: "",
          validation: []
        }
      ]
    };
  },
  computed: {
    ...mapState(["site_config", "contact_form_status"]),
    ...mapGetters(["eventTag"])
  },

  methods: {
    do_submit(app_mode) {
      let formData = new FormData();

      let valid_form = true;

      this.form_model.forEach((item) => {
        let valid_field = true;
        let validation = item.validation;
        let error_class = "border-red-500";
        validation.forEach((validation_type) => {
          switch (validation_type) {
            case "notempty":
              if (item.value.length <= 0) {
                valid_form = false;
                valid_field = false;
                error_class = "border-red-500";
              }

              break;
            case "notempty_array":
              if (item.value.length <= 0) {
                valid_form = false;
                valid_field = false;
                error_class = "text-red-500";
              }
              break;
          }
        });
        if (valid_field) {
          item.extra_class = "";
        } else {
          item.extra_class = error_class;
        }
      });

      //for debugging purposes, allow the form to always be valid
      //so we don't need to fill it in all the time
      if (!this.site_config.validate_form) {
        valid_form = true;
      }

      if (!valid_form) {
        return;
      }

      var data_to_submit = new FormData();

      this.form_model.forEach((item) => {
        data_to_submit.append(item.id, item.value);
      });

      this.$store.dispatch("submit_contact_form", data_to_submit);

      this.$refs.contact_form.reset();

      this.$ga.event(this.eventTag + "contact_form", "submit", "submit", 1);
    },
    reset_form() {
      this.$store.dispatch("set_contact_form_status", 0);

      this.form_model.forEach((item) => {
        if (item.id != "event_tag") {
          item.value = "";
        }
      });
    }
  },
  mounted() {
    this.form_model.forEach((item) => {
      if (item.id == "event_tag") {
        item.value = this.eventTag;
      }
    });
  },
  watch: {
    contact_form_status(val) {
      switch (val) {
        case 2:
        case 3:
          this.timer = setTimeout(this.reset_form.bind(this), 8000);
          break;
      }
    }
  }
};
</script>
<style scoped>
h1 {
  font-size: 36px;
  font-width: normal;
  margin: 15px 0 0;
  line-height: 1.1;
}
.form-content {
  margin-left: 17%;
}
.hidden-fields {
  height: 0;
  opacity: 0;
  transition: all 0.1s;
  overflow: hidden;
}
.hidden-fields.active {
  opacity: 1;
  height: auto;
}
.form-option-list {
  margin-top: 9px;
}
.form-option-list li {
  margin-bottom: 6px;
}
.form-option-list a {
  color: #2b6cb0;
}
</style>
<style>
.contact_form_page .simple-field-container {
}
.contact_form_page .required-indicator {
  display: none;
}
.contact_form_page .simple-field-container label,
.contact_form_page .simple-textarea-container label {
  min-width: 70px;
  font-size: 18px;
  font-weight: bold;
  display: inline-block;
  padding-right: 8px;
}
.contact_form_page .simple-field-container input[type="text"],
.contact_form_page textarea {
  background: #ebebeb;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  min-width: 350px;
  resize: none;
  max-width: 100%;
}

.form-instructions {
  font-size: 18px;
  width: 80%;
  margin-bottom: 16px;
}
body .contact_form_page .border-red-500,
body .contact_form_page .simple-field-container .border-red-500 {
  border-color: #f56565;
}

.top-deco {
  background-color: #151c6c;
  width: 71%;
  height: 20px;
  overflow: hidden;
}
.bottom-deco {
  background-color: #d4d844;
  width: 90%;
  height: 20px;
  margin: 14px auto 0;
  overflow: hidden;
}
.logo {
  display: block;
  margin: 100px 38px 0 60px;
}
.submit-container {
  font-size: 20px;
}

.thankyou-header {
  font-size: 62px;
  margin-bottom: 30px;
}
.thankyou-msg {
  font-size: 20px;
}
.thankyou-logo img {
  display: block;
  max-width: 240px;
  margin: 60px auto;
}
@media screen and (max-width: 638px) {
  body .form-content {
    margin-left: 0 !important;
    padding: 20px;
  }
  .contact_form_page input[type="text"],
  .contact_form_page textarea {
    min-width: 75% !important;
    width: 100%;
  }
  body .contact_form_page .simple-field-container {
    display: block;
  }
  body .contact_form_page label {
    display: block !important;
    font-size: 16px !important;
    margin-bottom: 4px;
  }
  .contact-form .close-link,
  .contact-form .option-bar {
    width: 40px !important;
    height: 40px !important;
  }
  h1 {
    font-size: 26px !important;
  }
  .logo {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/ContactFormPage.vue